import ArrowBack from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import PosterVideo from "../../components/poster/PosterVideo/PosterVideo";
import Footer from "../../components/layouts/Footer/Footer";
import PosterTimedContent from "../../components/ui-elements/PosterTimedContent/PosterTimedContent";
import { Poster } from "../../types/Poster";
import {
    backButtonContainer,
    backButton,
    pageContainer,
    logoContainer,
    logoImage,
    headlineContainer,
    headlineFirstLine,
    headlineSecondLine,
    headlineNumber,
} from "./posterDetailPageStyles";

interface PosterDetailProps {
    poster: Poster;
}

const PosterDetailPage: React.FC<PosterDetailProps> = ({ poster }) => {
    const navigate = useNavigate();
    const contentRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLDivElement>(null);
    const [showBackButton, setShowBackButton] = useState(false);

    const scrollToContent = () => {
        if (videoRef.current) {
            const videoHeight = videoRef.current.offsetHeight;

            window.scrollTo({
                top: videoHeight,
                behavior: "smooth",
            });
        }
    };

    const handlers = useSwipeable({
        onSwipedRight: () => navigate(-1),
        preventScrollOnSwipe: true,
        trackMouse: true,
    });

    useEffect(() => {
        const handleScroll = () => {
            if (videoRef.current) {
                const videoBottom =
                    videoRef.current.getBoundingClientRect().bottom;
                setShowBackButton(videoBottom <= 0);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box {...handlers} sx={pageContainer}>
            {poster.videoUrl && (
                <Box ref={videoRef}>
                    <PosterVideo
                        videoUrl={poster.videoUrl}
                        onVideoEnd={scrollToContent}
                    />
                </Box>
            )}

            {!poster.videoUrl && poster.imageUrl && (
                <Box
                    ref={videoRef}
                    component="img"
                    src={poster.imageUrl}
                    alt={poster.title}
                    sx={{
                        width: "100%",
                        height: "100dvh",
                        objectFit: "cover",
                    }}
                />
            )}

            {showBackButton && (
                <Box sx={backButtonContainer}>
                    <IconButton onClick={() => navigate(-1)} sx={backButton}>
                        <ArrowBack />
                    </IconButton>
                </Box>
            )}

            <Box sx={headlineContainer}>
                <Typography variant="h1" sx={headlineFirstLine}>
                    <Box component="span" sx={headlineNumber}>
                        1/87
                    </Box>{" "}
                    nummerierten Unikaten
                </Typography>
                <Typography variant="h2" sx={headlineSecondLine}>
                    ein exklusives Stück HSV-Geschichte
                </Typography>
            </Box>

            <Box sx={logoContainer}>
                <Box
                    component="img"
                    src="/images/illustrations/s_g_gold.png"
                    alt="S&G Gold"
                    sx={logoImage}
                />
            </Box>

            <Box ref={contentRef}>
                <PosterTimedContent />
            </Box>

            <Footer />
        </Box>
    );
};

export default PosterDetailPage;
